import React, { Component } from "react";

interface IProps {
  isActive: boolean;
}

export default class Spinners extends Component<IProps> {

  render() {
    if (!this.props.isActive) {
      return null;
    }


    return (
      <>
        <div className="loading-overlay">
          <span className="loader"></span>
        </div>
      </>
    );
  }
}